export default __webpack_public_path__ + "static/media/illustration-logo.55ca27a1.svg";